<template>
  <section class="main">
    <section class="top">
      <div href="" class="like">
        <div class="btn">
            <iframe src="//www.facebook.com/plugins/like.php?href=https://www.facebook.com/sealmobile.gm99%2F&amp;width=95&amp;layout=button_count&amp;action=like&amp;show_faces=false&amp;share=false&amp;height=21&amp" scrolling="no" frameborder="0" allowtransparency="true"></iframe>
        </div>
        <a href="//www.facebook.com/sealmobile.gm99" target="_blank" class="fb"></a>
      </div>
      <span class="video" @click="setVideo"></span>
      <div class="links">
        <div class="down-link mr20 qrCode">
          <img :src="gameInfo.qrCode" alt="">
        </div>
        <a class="apple" :href="gameInfo.appStoreDownLoadURL" target="_blank"></a>
        <a class="google" :href="gameInfo.googlePlayDownLoadURL" target="_blank"></a>
        <a class="apk" :href="gameInfo.apkDownLoadURL" target="_blank"></a>
        <a class="landie" v-if="!isMobile" href="https://www.bluestacks.com/tw/apps/role-playing/hope-meet-you-again-on-pc.html?utm_campaign=rf-g-mei-com.gm99.newseal" target="_blank"></a>
      </div>
      <div class="pc-top-slider">
        <swiper :options="swiperOptionTop">
          <swiper-slide v-for="(item, index) in slideList" :key="index">
            <a :href="item.URL" class="slider-link" target="_blank">
              <img :src="item.PIC_URL" alt="">
            </a>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination" v-if="slideList.length"></div>
        </swiper>
      </div>
      <div class="article-top">
        <div class="article-header">
          <ul class="article-header-list j-article-header-list">
            <li
              class="article-header-list-item"
              :class="{'active' : articleType === 'all'}"
              @click="articleType = 'all'"
            >
              <p class="article-header-list-item-zh">最新</p>
            </li>
            <li class="article-header-list-item"
              :class="{'active' : articleType === 'news'}"
              @click="getArticle('news')"
              >
              <p class="article-header-list-item-zh">新聞</p>
            </li>
            <li class="article-header-list-item"
              :class="{'active' : articleType === 'notices'}"
              @click="getArticle('notices')"
            >
              <p class="article-header-list-item-zh">公告</p>
            </li>
            <li class="article-header-list-item article-header-list-item-last"
              :class="{'active' : articleType === 'gamewiki'}"
              @click="getArticle('gamewiki')"
            >
              <p class="article-header-list-item-zh">資料</p>
            </li>
          </ul>
          <a :href="'./index.html#/article-list/?type=' + articleType" class="article-header-more more"></a>
        </div>
        <div class="article-main">
          <div class="swipe-wrap">
            <ul class="article-main-list" v-show="articleType === 'all'">
              <li class="article-main-list-item" v-for="(item, index) in article.all" :key="index">
                <a :href="'./index.html#/article-detail?id=' + item.ID + '&type=all'">
                  <span class="article-main-list-item-title">
                    <span class="article-main-list-item-title-inner">
                      <span class="type">{{articleTag['article' + item.ARTICLE_TYPE_ID] || '未提供'}}</span>{{item.TITLE || item.SHORT_TITLE}}
                    </span>
                  </span>
                  <span class="article-main-list-item-date">{{item.PUBLISH_TIME.substring(5, 10)}}</span>
                </a>
              </li>
            </ul>
            <ul class="article-main-list" v-show="articleType === 'news'">
              <li class="article-main-list-item" v-for="(item, index) in article.news" :key="index">
                <a :href="'./index.html#/article-detail?id=' + item.ID + '&type=news'">
                  <span class="article-main-list-item-title">
                    <span class="article-main-list-item-title-inner">
                      <span class="type">{{articleTag['article' + item.ARTICLE_TYPE_ID] || '未提供'}}</span>{{item.TITLE || item.SHORT_TITLE}}
                    </span>
                  </span>
                  <span class="article-main-list-item-date">{{item.PUBLISH_TIME.substring(5, 10)}}</span>
                </a>
              </li>
            </ul>
            <ul class="article-main-list" v-show="articleType === 'notices'">
              <li class="article-main-list-item" v-for="(item, index) in article.notices" :key="index">
                <a :href="'./index.html#/article-detail?id=' + item.ID + '&type=notices'">
                  <span class="article-main-list-item-title">
                    <span class="article-main-list-item-title-inner">
                      <span class="type">{{articleTag['article' + item.ARTICLE_TYPE_ID] || '未提供'}}</span>{{item.TITLE || item.SHORT_TITLE}}
                    </span>
                  </span>
                  <span class="article-main-list-item-date">{{item.PUBLISH_TIME.substring(5, 10)}}</span>
                </a>
              </li>
            </ul>
            <ul class="article-main-list" v-show="articleType === 'gamewiki'">
              <li class="article-main-list-item" v-for="(item, index) in article.gamewiki" :key="index">
                <a :href="'./index.html#/article-detail?id=' + item.ID + '&type=gamewiki'">
                  <span class="article-main-list-item-title">
                    <span class="article-main-list-item-title-inner">
                      <span class="type">{{articleTag['article' + item.ARTICLE_TYPE_ID] || '未提供'}}</span>{{item.TITLE || item.SHORT_TITLE}}
                    </span>
                  </span>
                  <span class="article-main-list-item-date">{{item.PUBLISH_TIME.substring(5, 10)}}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="introduce">
      <div class="introduce-header">
        <i class="prev" @click="prevIntroduce"></i>
        <ul class="nav">
          <li
            class="icon-jianshi"
            :class="{'active' : currIndroduceIndex === 0}"
            @click="setCurrIntroduce(0, 'left')"
          ></li>
          <li
            class="icon-qishi"
            :class="{'active' : currIndroduceIndex === 1}"
            @click="setCurrIntroduce(1, 'left')"
          ></li>
          <li
            class="icon-xiaochou"
            :class="{'active' : currIndroduceIndex === 2}"
            @click="setCurrIntroduce(2, 'left')"
          ></li>
          <li
            class="icon-fashi"
            :class="{'active' : currIndroduceIndex === 3}"
            @click="setCurrIntroduce(3, 'left')"
          ></li>
        </ul>
        <i class="next" @click="nextIntroduce"></i>
      </div>
      <transition :name="introduceAnimateName">
        <div class="jianshi" v-show="currIndroduceIndex === 0">
          <span class="hero-type">高攻/近戰</span>
          <span class="hero-des">勇者無畏，只有勇者才是最最可靠的——讓人放心的存在。</span>
          <span class="hero-skill">核心技能</span>
          <span class="hero-distance">轉職方向</span>
        </div>
      </transition>
      <transition :name="introduceAnimateName">
        <div class="qishi" v-show="currIndroduceIndex === 1">
          <span class="hero-type">高防/近戰</span>
          <span class="hero-des">完美是最有力的聖盾，是最強的守 護——凌駕於一切破壞和虛無之上。</span>
          <span class="hero-skill">核心技能</span>
          <span class="hero-distance">轉職方向</span>
        </div>
      </transition>
      <transition :name="introduceAnimateName">
        <div class="xiaochou" v-show="currIndroduceIndex === 2">
          <span class="hero-type">雙修/中程</span>
          <span class="hero-des">幕後行動才是最有趣的，與陰影為 伴——最最迷人的存在。</span>
          <span class="hero-skill">核心技能</span>
          <span class="hero-distance">轉職方向</span>
        </div>
      </transition>
      <transition :name="introduceAnimateName">
        <div class="fashi" v-show="currIndroduceIndex === 3">
          <span class="hero-type">群攻/遠程</span>
          <span class="hero-des">只有最充滿智慧并且嚴於律己的學 徒才能夠走上法師之路。</span>
          <span class="hero-skill">核心技能</span>
          <span class="hero-distance">轉職方向</span>
        </div>
      </transition>
    </section>
    <section class="feature">
      <div class="pc-feature-slider" v-if="!isMobile">
        <carousel-3d
            ref="mycarousel"
            :controls-visible="true"
            :clickable="false"
            :display="3"
            :autoplayTimeout="3000"
            :width="800"
            :height="450"
            :controlVisibile="true"
            @after-slide-change="onAfterSlideChange"
          >
          <slide v-for="(slide, i) in slides" :index="i" :key="i" :class="'slide' + slide"> </slide>
        </carousel-3d>
        <div slot="pagination" class="carousel-bottom-navs">
          <span class="carousel-bottom-nav" v-for="(slide, i) in slides" :key="i" :class="{'active': curCarouselIndex === 'curCarouselIndex-' + i}" @click="goToSlide(i)"></span>
        </div>
      </div>
      <div class="mobile-feature-slider" v-if="isMobile">
        <swiper :options="swiperOptionFeature">
          <swiper-slide class="slide1"></swiper-slide>
          <swiper-slide class="slide2"></swiper-slide>
          <swiper-slide class="slide3"></swiper-slide>
          <swiper-slide class="slide4"></swiper-slide>
          <swiper-slide class="slide5"></swiper-slide>
        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
    </section>
    <section class="facebook">
      <div
        class="fb-page"
        data-href="https://www.facebook.com/sealmobile.gm99"
        data-tabs="timeline"
        data-width="500"
        data-height="570"
        data-small-header="false"
        data-adapt-container-width="true"
        data-hide-cover="false"
        data-show-facepile="true"
      >
        <blockquote cite="https://www.facebook.com/sealmobile.gm99" class="fb-xfbml-parse-ignore">
          <a href="https://www.facebook.com/sealmobile.gm99"></a>
        </blockquote>
      </div>
    </section>
    <div class="alert-popup" id="video-iframe" v-show="showVideo"></div>
    <transition name="fadeIn">
      <div class="mask j-mask" v-show="showVideo" @click="closeVideo"></div>
    </transition>
  </section>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { Carousel3d, Slide } from 'vue-carousel-3d'
import { mapGetters } from 'vuex'
import { GAME_ID,
  GET_ARTICLE_LIST,
  ARTICLE_TYPE,
  GET_SLIDE_LIST
} from '../store/config'

export default {
  data () {
    return {
      slides: 5,
      curCarouselIndex: 0,
      introduceList: ['jianshi', 'qishi', 'xiaochou', 'fashi'],
      currIntroduceDistance: 'left',
      currIndroduceIndex: 0,
      articleType: 'all',
      swiperOptionTop: {
        width: 680,
        height: 300,
        autoplay: true,
        pagination: {
          el: '.pc-top-slider .swiper-pagination',
          clickable: true
        }
      },
      swiperOptionFeature: {
        width: 750,
        height: 424,
        pagination: {
          el: '.mobile-feature-slider .swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      article: {
        all: [],
        news: [],
        notices: [],
        gamewiki: []
      },
      articleTag: {
        article216: '新聞',
        article218: '公告',
        article217: '資料'
      },
      slideList: [],
      showVideo: 0
    }
  },
  computed: {
    introduceAnimateName () {
      if (this.isMobile) {
        return 'indroduce'
      } else {
        return this.currIntroduceDistance === 'left' ? 'indroduce-reverse' : 'indroduce'
      }
    },
    ...mapGetters([
      'gameInfo',
      'deviceType'
    ]),
    isMobile () {
      return this.deviceType === 'mobile'
    }
  },
  created () {
    const params = {
      gameId: GAME_ID,
      type: ARTICLE_TYPE['all']
    }
    this.$store.dispatch(GET_ARTICLE_LIST, params).then((res) => {
      this.article['all'] = res.list
    })
    this.$store.dispatch(GET_SLIDE_LIST, { gameId: GAME_ID }).then((res) => {
      this.slideList = res.list
    })
    if (!this.isMobile) {
      this.$nextTick(() => {
        this.goToSlide(0)
      })
    }
  },
  methods: {
    prevIntroduce () {
      this.currIntroduceDistance = 'left'
      if (this.currIndroduceIndex <= 0) {
        this.currIndroduceIndex = this.introduceList.length - 1
      } else {
        this.currIndroduceIndex -= 1
      }
    },
    nextIntroduce () {
      this.currIntroduceDistance = 'right'
      if (this.currIndroduceIndex >= this.introduceList.length - 1) {
        this.currIndroduceIndex = 0
      } else {
        this.currIndroduceIndex += 1
      }
    },
    setCurrIntroduce (index, distrance) {
      this.currIndroduceIndex = index
      this.currIntroduceDistance = distrance
    },
    getArticle (type) {
      this.articleType = type
      const params = {
        gameId: GAME_ID,
        type: ARTICLE_TYPE[type]
      }
      if (this.article[type].length) {
        return
      }
      this.$store.dispatch(GET_ARTICLE_LIST, params).then((res) => {
        this.article[type] = res.list
      })
    },
    setVideo () {
      this.showVideo = 1
      const videoUrl = 'https://www.youtube.com/embed/wmlqgrH97to'
      const html = '<iframe  src="' + videoUrl + '" frameborder="0" allowfullscreen width="600" height="400"></iframe>'
      document.getElementById('video-iframe').innerHTML = html
    },
    closeVideo () {
      this.showVideo = false
      document.getElementById('video-iframe').innerHTML = ''
    },
    onAfterSlideChange (index) {
      this.curCarouselIndex = 'curCarouselIndex-' + index
    },
    goToSlide (index) {
      this.$refs.mycarousel.goSlide(index)
    }
  },
  components: {
    swiper,
    swiperSlide,
    Carousel3d,
    Slide
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/main.scss";
</style>
